import React, { Component } from 'react';
import styled from 'styled-components';

import { Font } from '../../../../utils/fonts';
import mediaWidth from '../../../../utils/mediaWidth/mediaWidth';

// import DesktopForwardButton from '../DesktopForwardButton';

class Rule extends Component {
    render() {
        // const { className, handleClick } = this.props;
        const { className } = this.props;
        return (
            <Root className={className}>
                <MobileRule>Зажмите джойстик и перемещайте шарик, чтобы пройти лабиринт</MobileRule>
                <DesctopRule>
                    Зажмите левую кнопку мыши и перемещайте шарик, чтобы пройти лабиринт
                    {/* <StyledDesktopForwardButton handleClick={handleClick} /> */}
                </DesctopRule>
            </Root>
        );
    }
}

// const StyledDesktopForwardButton = styled(DesktopForwardButton)`
//     display: none;
//     ${mediaWidth.l} {
//         display: inline-block;
//     }
// `;

const MobileRule = styled.div`
    width: 316px;
    text-align: center;

    ${mediaWidth.m} {
        width: 458px;
    }

    ${mediaWidth.l} {
        display: none;
    }
`;

const DesctopRule = styled.div`
    display: none;

    ${mediaWidth.l} {
        display: block;
        width: 359px;
    };

    ${mediaWidth.xl} {
        width: 367px;
    }
`;

const Root = styled.div`
    ${Font.PRIMARY};
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    color: rgba(0,0,0,.5);
`;

export default Rule;
